import { FolderIcon } from "lucide-react";

import { SidebarGroup, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "../ui/sidebar";
import { useHostedProjectStore } from "../../hosted/hostedProjectStore";
import { useHostedModeState } from "../../hosted/useHostedMode";
import { useHostedProjects } from "../../hosted/useHostedProjects";

/**
 * Hosted Roblox projects in the sidebar.
 *
 * Hosted projects have no workspace root, so they can't flow through T3's
 * environment-scoped project grouping. This renders them as their own compact
 * group and only when hosted surfaces are live (hosted origin, no local
 * environment, Clerk provider mounted), leaving the local project list
 * untouched everywhere else.
 */
export function HostedSidebarProjects() {
  const { hostedSurfacesEnabled } = useHostedModeState();

  if (!hostedSurfacesEnabled) {
    return null;
  }

  return <MountedHostedSidebarProjects />;
}

function MountedHostedSidebarProjects() {
  const { projects, status, selectProject } = useHostedProjects();
  const selectedProjectId = useHostedProjectStore((state) => state.selectedProjectId);

  return (
    <SidebarGroup className="px-2 py-2" data-testid="hosted-sidebar-projects">
      <div className="mb-1 flex items-center justify-between pl-2 pr-1.5">
        <span className="text-xs font-medium text-sidebar-muted-foreground/80">
          Roblox projects
        </span>
      </div>
      {projects.length === 0 ? (
        <div className="px-2 py-2 text-center text-xs text-muted-foreground/60">
          {status === "loading" ? "Loading projects…" : "No projects yet"}
        </div>
      ) : (
        <SidebarMenu>
          {projects.map((project) => (
            <SidebarMenuItem key={project.id}>
              <SidebarMenuButton
                isActive={project.id === selectedProjectId}
                onClick={() => selectProject(project.id)}
              >
                <FolderIcon />
                <span className="truncate">{project.name}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      )}
    </SidebarGroup>
  );
}
